import Axios from 'axios'
import requestPrefix from '../requestPrefix'

export default {
  // 今日考勤信息
  mobilecheckintoday(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/mobile/checkin/today',
      method: 'get',
      params: args
    })
  },
  // 出勤率
  mobilecheckinrate(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/mobile/checkin/rate',
      method: 'get',
      params: args
    })
  },
  // 考勤列表
  mobilecheckinlist(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/mobile/checkin/list',
      method: 'get',
      params: args
    })
  },
  // 在场人数
  countOnSite(args) {
    return Axios({
      url: requestPrefix.projectUrl + '/accessRecord/countOnSite',
      method: 'get',
      params: args
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/checkinmanage/index.js